import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=55c3c8f2"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c3c8f2')) {
      api.createRecord('55c3c8f2', component.options)
    } else {
      api.reload('55c3c8f2', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=55c3c8f2", function () {
      api.rerender('55c3c8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Index.vue"
export default component.exports